import { Link } from "react-router-dom";
import { Icon } from "./components";
import { money } from "./format";

/**
 * Die störenden Belege einer abgelehnten „Annahme zurücknehmen“-Anfrage (04.11.2026, Sackgasse). Leitregel
 * (Antoine): keine Sperre ohne verständlichen Satz und direkten Ausweg — jede Zeile nennt Beleg, Status und den einen
 * nächsten Schritt und führt mit einem Link dorthin, wo er ausgeführt wird. Die Liste kommt vom Server
 * (`stoerendeBelege` in der Antwort `belege_vorhanden`), die Oberfläche rechnet nichts nach.
 */
export interface StoerenderBeleg {
  art: "zahlung" | "rechnung" | "kostenuebernahme" | "abrechnung";
  id: string;
  bezeichnung: string;
  betragCents: number | null;
  status: string;
  statusText: string;
  schritt: string;
  ziel: string;
}

const ICON: Record<StoerenderBeleg["art"], string> = { zahlung: "payments", rechnung: "receipt_long", kostenuebernahme: "draw", abrechnung: "calculate" };

export function AnnahmeBelegeListe({ belege }: { belege: StoerenderBeleg[] }) {
  if (belege.length === 0) return null;
  return (
    <div className="mt-3" data-testid="annahme-stoerende-belege">
      <p className="font-body-sm text-body-sm font-semibold text-on-background dark:text-inverse-on-surface">
        Die Annahme lässt sich noch nicht zurücknehmen, weil {belege.length === 1 ? "ein Beleg" : `${belege.length} Belege`} am Vorgang {belege.length === 1 ? "hängt" : "hängen"}:
      </p>
      <ul className="mt-2 space-y-2">
        {belege.map((b) => (
          <li key={`${b.art}-${b.id}`} className="rounded-lg border border-outline-variant/40 p-2.5 dark:border-outline/30" data-testid={`annahme-beleg-${b.art}`}>
            <div className="flex items-start justify-between gap-3">
              <p className="flex items-center gap-1.5 font-body-sm text-[12.5px] font-semibold text-on-background dark:text-inverse-on-surface">
                <Icon name={ICON[b.art]} className="text-[16px]" /> {b.bezeichnung}
              </p>
              {b.betragCents != null && <span className="font-body-sm text-[12.5px] font-semibold text-on-background dark:text-inverse-on-surface">{money(b.betragCents)}</span>}
            </div>
            <p className="mt-0.5 font-label-md text-[11px] text-secondary dark:text-secondary-fixed-dim">{b.statusText}</p>
            <p className="mt-1 font-body-sm text-[12px] text-on-background dark:text-inverse-on-surface">{b.schritt}</p>
            <Link to={b.ziel} className="mt-1 inline-flex items-center gap-1 font-label-md text-[11.5px] font-semibold text-primary hover:underline">
              Zum Beleg <Icon name="arrow_forward" className="text-[14px]" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
